<template>
  <span class="copyright caption" v-html="parsedCopyright" />
</template>
<script lang="ts" setup>
const props = defineProps<{ copyright: string }>()

const parsedCopyright = computed(() => {
  return parseCopyright(props.copyright)
})
</script>
